import { ExperienceTransferItemWire } from '../types';
import { ExperienceTransferItem } from 'app/area/experience-transfer/form/types-store';

export const mapExperienceTransferFromWire = (wire: Partial<ExperienceTransferItemWire>): ExperienceTransferItem => ({
  id: wire?.id,
  active: wire?.active,
  criteria: { value: wire?.criteria?.v, description: wire?.criteria?.d },
  caseType: { value: wire?.caseType?.v, description: wire?.caseType?.d },
  operation: { value: wire?.operation?.v, description: wire?.operation?.d },
  subscriberGroup: { value: wire?.subscriberGroup?.v, description: wire?.subscriberGroup?.d }
});

export const mapExperienceTransferToWire = (experienceTransfer: ExperienceTransferItem): ExperienceTransferItemWire => ({
  id: experienceTransfer?.id,
  active: experienceTransfer?.active,
  criteria: { v: experienceTransfer?.criteria?.value, d: experienceTransfer?.criteria?.description },
  caseType: { v: experienceTransfer?.caseType?.value, d: experienceTransfer?.caseType?.description },
  operation: { v: experienceTransfer?.operation?.value, d: experienceTransfer?.operation?.description },
  subscriberGroup: { v: experienceTransfer?.subscriberGroup?.value, d: experienceTransfer?.subscriberGroup?.description }
});
